































































import Vue from 'vue';

import { AuthenticationMethod, defaultAuthenticationMethod } from '@/authentication';

interface Data {
    authenticationMethod: AuthenticationMethod | null;
}

export default Vue.extend({
    props: {
        loginUrl: {
            type: String,
            required: true,
        },
    },
    data: (): Data => ({
        authenticationMethod: null,
    }),
    computed: {
        authenticationMethods(): AuthenticationMethod[] {
            return Object.values(AuthenticationMethod) as AuthenticationMethod[];
        },
        authenticationMethodNames(): Record<AuthenticationMethod, string> {
            return {
                [AuthenticationMethod.Inrupt]: 'Inrupt\'s authentication library',
                [AuthenticationMethod.Legacy]: 'the legacy authentication library',
            };
        },
        authenticationMethodDescriptions(): Record<AuthenticationMethod, string> {
            return {
                [AuthenticationMethod.Inrupt]:
                    'Inrupt\'s authentication library uses DPoP, and most servers should work using this method.',
                [AuthenticationMethod.Legacy]:
                    'This authentication method is no longer recommended, but some old servers may need to use it.',
            };
        },
        authenticationMethodUrls(): Record<AuthenticationMethod, string> {
            return {
                [AuthenticationMethod.Inrupt]: 'https://github.com/inrupt/solid-client-authn-js',
                [AuthenticationMethod.Legacy]: 'https://github.com/solid/solid-auth-client',
            };
        },
        authenticationMethodDescription(): string | null {
            return this.authenticationMethod && this.authenticationMethodDescriptions[this.authenticationMethod];
        },
        authenticationMethodUrl(): string | null {
            return this.authenticationMethod && this.authenticationMethodUrls[this.authenticationMethod];
        },
    },
    mounted() {
        (this.$refs['login-url-input'] as HTMLInputElement).focus();
    },
    methods: {
        showAuthenticationMethods(): void {
            this.authenticationMethod = defaultAuthenticationMethod;

            this.$nextTick(() => (this.$refs['authentication-method-select'] as HTMLSelectElement).focus());
        },
    },
});
